import React from "react";
import PropTypes from "prop-types";

export default function OptionsWrapper({ children, ...props }) {
  return (
    <div
      css={{
        "> :first-of-type": {
          paddingTop: 20,
        },
        "> :last-of-type": {
          paddingBottom: 20,
        },
      }}
      {...props}
    >
      {children}
    </div>
  );
}

OptionsWrapper.propTypes = {
  children: PropTypes.any.isRequired,
};
